export const PROJECTS_DATA = [
  {
    slug: "wellness-arena",
    number: "01",
    title: "Wellness Arena",
    industry: "Gym & Wellness",
    status: "LIVE",
    statusLabel: "Live Website",
    overview:
      "A modern wellness and fitness website designed to help businesses attract more members through a clean user experience, online appointment booking, and an admin dashboard.",
    features: [
      "Appointment Booking",
      "Admin Dashboard",
      "MongoDB Database",
      "Contact Forms",
      "Responsive Design",
      "Google Maps",
      "Premium UI",
      "Fast Performance",
    ],
    tech: ["React", "FastAPI", "MongoDB"],
    liveUrl: "https://www.wellness-arena.fit",
    desktopImg: "/projects/wellness-desktop.jpg",
    mobileImg: "/projects/wellness-mobile.jpg",
    accent: "#E2FF31",
    browserUrl: "wellness-arena.fit",
    align: "left",
  },
  {
    slug: "luxury-salon",
    number: "02",
    title: "Luxury Salon Concept",
    industry: "Luxury Hair & Beauty Salon",
    status: "CONCEPT",
    statusLabel: "Portfolio Concept",
    overview:
      "A premium salon website concept featuring elegant branding, luxury aesthetics, appointment booking and a modern customer experience.",
    features: [
      "Luxury UI",
      "Appointment Booking",
      "Responsive Design",
      "Elegant Layout",
      "Contact Form",
      "Gallery",
      "Service Pages",
      "Premium Animations",
    ],
    tech: ["React", "FastAPI", "MongoDB"],
    liveUrl: "https://salon-demo-production-9605.up.railway.app",
    desktopImg: "/projects/salon-desktop.jpg",
    mobileImg: "/projects/salon-mobile.jpg",
    accent: "#E2FF31",
    browserUrl: "salon-demo-production-9605.up.railway.app",
    align: "right",
  },
  {
    slug: "artisan-coffee",
    number: "03",
    title: "Artisan Coffee Concept",
    industry: "Café",
    status: "CONCEPT",
    statusLabel: "Portfolio Concept",
    overview:
      "A modern café website concept with an AI Barista Assistant, reservation functionality, premium branding and a clean customer experience.",
    features: [
      "AI Barista Assistant",
      "Table Reservation",
      "Interactive Menu",
      "Location Map",
      "Responsive Design",
      "Modern Aesthetics",
    ],
    tech: ["React", "FastAPI", "MongoDB"],
    liveUrl: "https://cafe-demo-production-f14f.up.railway.app",
    desktopImg: "/projects/coffee-desktop.jpg",
    mobileImg: "/projects/coffee-mobile.jpg",
    accent: "#E2FF31",
    browserUrl: "cafe-demo-production-f14f.up.railway.app",
    align: "left",
  },
];

// Alias export to prevent any component import mismatches
export const projects = PROJECTS_DATA;
export default PROJECTS_DATA;
